










































import Vue from "vue";
import { Component, Prop, Watch, Emit } from "vue-property-decorator";

@Component
export default class PopUp extends Vue {
  @Prop({ default: false }) readonly shown!: boolean;
  @Prop({ default: "" }) readonly color!: string;
  @Prop({ default: "" }) readonly title!: string;
  @Prop({ default: "" }) readonly message!: string;

  @Emit("warningConfirmed")
  emitWarningConfirmed() {
    return true;
  }
  @Emit("completeConfirmed")
  emitCompleteConfirmed() {
    return true;
  }
  @Emit("saveConfirmed")
  emitSaveConfirmed() {
    return true;
  }

  @Emit("closed")
  emitClosed() {
    return true;
  }
}
